import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  return <section id="footer" className="bg-[#1A2129] text-[#637381] py-12 px-6 md:px-12 font-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8 text-center md:text-left">
          {}
          <div className="col-span-1 flex flex-col items-center md:items-start gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600388/img/crash_report_finder_logo.png" alt="Crash Report Finder" className="h-7 w-auto object-contain" />
            <p className="text-sm">
              Providing fast, secure, and comprehensive access to your accident reports nationwide.
            </p>
          </div>

          {}
          <div className="col-span-1 md:col-span-3 text-[12px] leading-relaxed text-center md:text-left">
            <p>By submitting this request, you authorize crashreportfinder.com to share your information with one of its sponsors, allowing them to contact you via phone or text regarding your accident.&nbsp;</p>
          </div>
        </div>

        <Separator className="bg-[#212B36] my-6" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[12px]">
          <p>&copy; {new Date().getFullYear()} Crash Report Finder. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="https://crashreportfinder.com/terms-of-use" className="text-[#FF6600] hover:underline transition-colors">
              Terms of Use
            </Link>
            <Link to="https://crashreportfinder.com/privacy-policy" className="text-[#FF6600] hover:underline transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}